/**
 * System / room header labels.
 * Proposal live tabs use classification/display maps; VO lines use placement display.
 */

import { resolveSystemDisplayLabel, type DtoolsReviewBuildContext } from "../dtoolsReviewNavigation";
import type { DtoolsReviewSystem } from "../dtoolsStagingTransform";
import { displayVoRoom, displayVoSystem } from "../variationOrderPresentation";
import type { VoDeltaLine } from "../variationOrderDiff";

export function renderSystemHeaderLabel(
  system: DtoolsReviewSystem,
  context?: DtoolsReviewBuildContext,
  optionIndex = 0,
): string {
  return resolveSystemDisplayLabel(system, context, optionIndex);
}

export function renderVoSystemHeader(
  line: Pick<VoDeltaLine, "systemId" | "systemName" | "systemKey">,
): string {
  return displayVoSystem(line);
}

export function renderVoRoomHeader(
  line: Pick<VoDeltaLine, "roomId" | "roomName" | "roomKey">,
): string {
  return displayVoRoom(line);
}
